import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Divider,
  Alert,
  CircularProgress,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import DownloadIcon from "@mui/icons-material/Download";
import ScoreIcon from "@mui/icons-material/Score";
import ScheduleIcon from "@mui/icons-material/Schedule";
import "./Files.css";

const DashboardTemplate = () => {
  // Available documents for download
  const documents = [
    {
      name: "Competition Agenda 2025",
      link: "https://drive.google.com/uc?export=download&id=1Cqq8qlNWJX9axZDZp_IVTuSTwud9Xsu5",
      filename: "IRC_Agenda_2025.pdf",
    },
    {
      name: "Bowling Schedule 2025",
      link: "https://drive.google.com/uc?export=download&id=1cxPILj5ZSQC59_FE1M5TwE7PhVHQFutq",
      filename: "Bowling_2025.pdf",
    },
    {
      name: "Follow line (Enhanced) Schedule 2025",
      link: "https://drive.google.com/uc?export=download&id=1euk1cJwcD26LPzS0YBQUEL1My1nirjyS",
      filename: "Follow_line_enhanced_2025.pdf",
    },
    {
      name: "Follow line (Open) Schedule 2025",
      link: "https://drive.google.com/uc?export=download&id=1upybwAGyxJigL00KuMhBJ_y0xMSZK5vF",
      filename: "Follow_line_open_2025.pdf",
    },
    {
      name: "Follow line (Lego) Schedule 2025",
      link: "https://drive.google.com/uc?export=download&id=1-OJgsaoMYdUUa_-2V9UdD78s0LH0NpqQ",
      filename: "Follow_line_lego_2025.pdf",
    },
    {
      name: "Free Style Schedule 2025",
      link: "https://drive.google.com/uc?export=download&id=15lcbBGAWNE7L5xFHBxVKQPgb6cart1I4",
      filename: "Free_style_2025.pdf",
    },
    {
      name: "Puck Collect Schedule 2025",
      link: "https://drive.google.com/uc?export=download&id=1RmaL6guErfDqG-0DF0V5iRCGCnwcAK-d",
      filename: "Puck_collect_2025.pdf",
    },
    {
      name: "Robo Boom Schedule 2025",
      link: "https://drive.google.com/uc?export=download&id=1R3QvFDsgyvXXW5WDJeWcna9kSyoUih3J",
      filename: "Robo_boom_2025.pdf",
    },
    {
      name: "Robo Golf Schedule 2025",
      link: "https://drive.google.com/uc?export=download&id=1lrs6xg-6Q4NHxBUNB85H9WYFyugf1Bo9",
      filename: "Robo_golf_2025.pdf",
    },
    {
      name: "Sumo (Mega) Schedule 2025",
      link: "https://drive.google.com/uc?export=download&id=1I0HWZ6uOOI9t74uKLwGIzJmDProTFtaX",
      filename: "Sumo_mega_2025.pdf",
    },
    {
      name: "Sumo (Mini) Schedule 2025",
      link: "https://drive.google.com/uc?export=download&id=1ZIaslT1i3-wLxdIrU5hgbdnQ0nJHkr9h",
      filename: "Sumo_mini_2025.pdf",
    },
    {
      name: "Sumo (Lego) Schedule 2025",
      link: "https://drive.google.com/uc?export=download&id=1_F6Qf4dCmM9RcFKx1d9Yv-6uALs_FhND",
      filename: "Sumo_lego_2025.pdf",
    },
  ];

  const handleDownload = (document) => {
    window.open(document.link, "_blank");
  };

  return (
    <Box
      sx={{
        width: "100%",
        padding: { xs: "50px 20px", sm: "50px 60px", lg: "50px 120px" },
        maxWidth: "1500px",
        margin: "auto",
        minHeight: "80vh",
      }}
    >
      <Typography
        variant={"h1"}
        sx={{
          textAlign: "center",
          fontSize: { xs: "40px", sm: "50px" },
          fontWeight: "500",
          color: "primary.darker",
        }}
      >
        Robot Challenge Egypt 2025
      </Typography>
      <Box
        sx={{
          height: "3px",
          maxWidth: { xs: "100px", md: "150px" },
          width: "100%",
          backgroundColor: "primary.main",
          margin: "auto",
          marginBottom: "50px",
          marginTop: "10px",
        }}
      />

      <Grid container spacing={4}>
        {/* Documents Section */}
        <Grid item xs={12} lg={12}>
          <Card sx={{ height: "100%" }}>
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "20px",
                }}
              >
                <ScheduleIcon
                  sx={{
                    color: "primary.main",
                    marginRight: "10px",
                    fontSize: "30px",
                  }}
                />
                <Typography
                  variant="h4"
                  sx={{ color: "primary.darker", fontWeight: "600" }}
                >
                  Competition Schedules
                </Typography>
              </Box>

              <Typography
                variant="body1"
                sx={{ color: "primary.darker", marginBottom: "20px" }}
              >
                Download the latest competition agenda, schedules, and other
                important documents.
              </Typography>

              <Grid container spacing={2}>
                {documents.map((doc, index) => (
                  <Grid item xs={12} md={6} lg={4} key={index}>
                    <Card
                      variant="outlined"
                      sx={{
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        "&:hover": {
                          boxShadow: 3,
                          transform: "translateY(-2px)",
                        },
                      }}
                      onClick={() => handleDownload(doc)}
                    >
                      <CardContent sx={{ padding: "16px !important" }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box>
                            <Typography
                              variant="h6"
                              sx={{
                                color: "primary.darker",
                                fontWeight: "600",
                              }}
                            >
                              {doc.name}
                            </Typography>
                            {/* <Typography
                              variant="body2"
                              sx={{ color: "text.secondary" }}
                            >
                              {doc.description}
                            </Typography> */}
                          </Box>
                          <DownloadIcon sx={{ color: "primary.main" }} />
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DashboardTemplate;
